<template>
  <div class="overlay overlay--grow" v-show="modalVisible">
    <transition name="slideDown">
      <div>
        <div ref="target" class="overlay__inner pad-btm-20" v-show="modalVisible" @click.stop>
          <div class="app-modal app-modal--notes">
            <h3 
              class="app-modal__head app-modal__head--main" 
              @mouseenter="moveable.draggable = true"
              @mouseleave="moveable.draggable = false"
            >Notes</h3>

            <div class="app-modal__inner">

              <div class="row">
                <div class="col font-weight-bold align-rt" style="width: 100%; max-width: 120px;">Adjustment:</div>
                <div class="col">
                  <span v-if="brokerFee">{{ formatCurrency(brokerFee, 6) }}/KWh</span>
                  <i v-else>None entered</i>
                </div>
              </div>

              <div class="row">
                <div class="col col--edit-btn" style="width: 100%; max-width: 120px;">
                  <a v-if="isEditingAdjustmentNotes" href="#" class="sz-n" @click.prevent="cancelEditingAdjustmentNotes">(Cancel)</a>
                  <a v-else href="#" class="sz-n" @click.prevent="isEditingAdjustmentNotes = true">(Edit)</a>
                </div>
                <div class="col">
                  <input 
                    v-if="isEditingAdjustmentNotes"
                    type="text" 
                    v-model="adjustmentNotes" 
                  >
                  <span v-else-if="adjustmentNotes">{{ adjustmentNotes }}</span>
                  <i v-else>None entered</i>
                </div>
              </div>

              <div class="row">
                <div class="col" style="width: 100%; max-width: 120px;">
                  <label for="notes">General Notes:</label>
                </div>
                <div class="col">
                  <label><i class="pacific">{{ notesCharsRemaining }} characters remaining</i></label>
                  <textarea v-model="notes" id="notes" :maxlength="notesMaxChars"></textarea>
                </div>
              </div>
            </div> <!--  .app-modal__inner -->

            <div class="app-modal__footer">
              <button 
                type="button" 
                class="btn mrgn-right-15"
                @click="save()"
              >Submit</button>

              <a 
                href="#" 
                @click.prevent="cancel()" 
                class="sz-n"
              >Cancel</a>
            </div>
          </div>
        </div>

        <Moveable
          className="moveable"
          :target="$refs.target"
          :draggable="moveable.draggable"
          :origin="false"
          @drag="handleDrag"
        />
      </div>

    </transition>
  </div>
</template>

<script>
import Moveable from 'vue3-moveable'
import swal from 'sweetalert'
import { formatCurrency, formatNumber } from  '../../../common/helpers.js'

export default {
  props: {
    modalVisible: {
      type: Boolean,
    },
    priceRequest: {
      type: Object,
    },
  },
  data() {
    return {
      modal: null,
      isEditingAdjustmentNotes: false,
      initialAdjustmentNotes: '',
      adjustmentNotes: '',
      initialNotes: '',
      notes: '',
      notesMaxChars: 500,
      moveable: {
        draggable: false,
      },
    }
  },
  emits: ['save', 'close'],
  components: {
    Moveable,
  },
  computed: {
    /**
     * Determine the number of remaining notes characters.
     */
    notesCharsRemaining() {
      if (this.notes) {
        return formatNumber(this.notesMaxChars - this.notes.length)
      }
      return formatNumber(this.notesMaxChars)
    },
    /**
     * Get the adjustment/broker fee.
     */
    brokerFee() {
      if (this.customFacilityProfileExists) {
        return this.priceRequest?.inputs?.customFacilityVolume?.brokerFee
      }
      return this.priceRequest?.inputs?.volume?.brokerFee
    },
    /**
     * Determine if the price request uses a custom facility profile.
     */
    customFacilityProfileExists() {
      return this.priceRequest?.inputs?.customFacilityProfile && 
             Object.keys(this.priceRequest.inputs.customFacilityProfile).length > 0
    },
  },
  watch: {
    modalVisible(newValue) {
      if (newValue) {

        // Custom profile?
        if (this.customFacilityProfileExists) {
          this.adjustmentNotes = this.initialAdjustmentNotes = this.priceRequest?.inputs?.customFacilityVolume?.adjustmentNotes || ''
          this.notes = this.initialNotes = this.priceRequest?.inputs?.customFacilityVolume?.notes || ''

        // ...otherwise non-custom profile.
        } else {
          this.adjustmentNotes = this.initialAdjustmentNotes = this.priceRequest?.inputs?.volume?.adjustmentNotes || ''
          this.notes = this.initialNotes = this.priceRequest?.inputs?.volume?.notes || ''
        }
      } else {
        this.adjustmentNotes = this.initialAdjustmentNotes = ''
        this.notes = this.initialNotes = ''
      }
    }
  },
  methods: {
    /**
     * Save the notes.
     */
    save() {
      this.$emit('save', this.priceRequest, {
        adjustmentNotes: this.adjustmentNotes,
        notes: this.notes
      })

      this.$emit('close')
      this.isEditingAdjustmentNotes = false
    },
    /**
     * Cancel and close the modal.
     */
    cancel() {
      this.isEditingAdjustmentNotes = false
      this.adjustmentNotes = this.initialAdjustmentNotes
      this.notes = this.initialNotes
      this.$emit('close')
    },
    /**
     * Cancel editing the adjustment notes.
     */
    cancelEditingAdjustmentNotes() {
      this.adjustmentNotes = this.initialAdjustmentNotes
      this.isEditingAdjustmentNotes = false
    },
    /**
     * Handle the modal drag.
     */
    handleDrag({ target, transform }) {
      let ogTransform = target.style.transform

      target.style.transform = transform

      let bounding = target.getBoundingClientRect();

      if (bounding.top < 0) {
        target.style.transform = ogTransform
      }
    },
    /**
     * Format currency.
     */
    formatCurrency(val, decimals) {
      return formatCurrency(val, decimals)
    },
    /**
     * Format a number.
     */
    formatNumber(val, decimals) {
      return formatNumber(val, decimals)
    },
  }
}
</script>
